import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: stretch;
  gap: 1.5rem;
  padding: 4rem 0;
`;
